<template>
	<div class="rebag">
		<TwoHeader></TwoHeader>
		<div class="bgcontent">
			<div class="box-card">
				<LeftNav></LeftNav>
				<div class="baoright">
					<h2 class="yutitle" v-if="show"><span></span>{{ info.examinationInfoName }}</h2>
					<h2 class="yutitle" v-else>暂无成绩数据</h2>
					<table class="toptable" v-if="show">
						<!--					<table class="toptable" >-->
						<tr style="height:60px;">
							<td valign="center" rowspan="1" colspan="4"
								style="text-align:left;border:none;font-weight: bold;">
								姓名：<span>{{ $store.state.userexaminfo.registrationName}}</span>
							</td>
							<td valign="center" rowspan="1" colspan="4"
								style="text-align:left;border:none;font-weight: bold;">
								准考证号：<span>{{ info.cardNo}}</span>
							</td>
							<td valign="center" rowspan="1" colspan="4"
								style="text-align:left;border:none;font-weight: bold;">
								身份证号：<span>{{ $store.state.userexaminfo.idcard}}</span><br />
							</td>
						</tr>
						<tr>
							<td valign="center" rowspan="1" colspan="4" class="yusteon">笔试总成绩</td>
							<td valign="center" rowspan="1" colspan="3" class="yutext">{{ info.result }}</td>
							<td valign="center" rowspan="1" colspan="2" class="yusteon">排名</td>
							<td valign="center" rowspan="1" colspan="3" class="yutext">{{ info.ord }}</td>
						</tr>

						<tr v-if="info.subjectResultOne">
							<td valign="center" rowspan="1" colspan="4" class="yusteon">{{pisitioninfo.subjectOneName}}
							</td>
							<td valign="center" rowspan="1" colspan="8">{{ info.subjectResultOne }}</td>
						</tr>
						<tr v-if="info.subjectResultTwo">
							<td valign="center" rowspan="1" colspan="4" class="yusteon">
								{{ pisitioninfo.subjectTwoName }}
							</td>
							<td valign="center" rowspan="1" colspan="8">{{ info.subjectResultTwo }}</td>
						</tr>
						<tr>
							<td valign="center" rowspan="1" colspan="12" class="yusteon" style="color: #ff0000">
								温馨提示：-1代表缺考</td>
						</tr>
					</table>
					<div v-show="info.mianshiFlag==1" @click="mianshi" class="dayin">点击前往打印面试通知单</div>
				</div>
			</div>
		</div>
		<TowFooTer></TowFooTer>
	</div>
</template>

<script>
	import TowFooTer from '../components/common/towfooter.vue'
	import TwoHeader from '../components/common/twoheader.vue'
	import LeftNav from '../components/common/leftnav.vue'
	import {
		examinationResult,
		getpositionbyid
	} from "@/api/api"
	export default {
		name: "chengji",
		components: {
			TwoHeader,
			LeftNav,
			TowFooTer
		},
		data() {
			return {
				info: {},
				show: false,
				pisitioninfo: {}

			}
		},
		created() {
			getpositionbyid({
				positionid: this.$store.state.userexaminfo.positionId
			}).then(res => {

				this.pisitioninfo = res.data.data;

			})
			examinationResult({
				'examinationId': this.$store.state.examid
			}, this.$store.state.token).then(res => {
				if (res.data.data.length > 0) {
					this.show = true
					this.info = res.data.data[0];
				}

			})
		},
		methods: {
			mianshi: function() {
				this.$router.push({
					path: '/mianshi'
				})
			}
		}
	}
</script>

<style scoped="">
	.dayin {
		width: 100%;
		text-align: right;
		font-size: 24px;
		padding-top: 40px;
		color: blue;
		text-decoration: underline;
		cursor: pointer;
	}

	.rebag {
		background: url('../assets/denglu.png');
		background-size: cover;

	}

	.bright {
		float: right;
	}

	.brightp {
		line-height: 130px;
		color: #FFFFFF !important;
		font-size: 16px;
		margin-left: 20px;
		list-style: none;
	}

	.brightp i {
		font-size: 20px;
	}

	.bgcontent {
		margin-top: 40px;
		min-height: 740px;
	}

	.el-card {
		border: none;
	}

	.box-card {
		margin: 0 auto;
		width: 1200px;
		margin: 0 auto;
		height: auto;
		overflow: hidden;
		margin-bottom: 50px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
		background-color: #ECF4FF;
	}

	.baoimeg {
		width: 180px;
		background: linear-gradient(to left, #54abff 0%, #0048d0 100%);
		display: block;
		height: 64px;
		line-height: 64px;
		color: #ffffff;
	}

	.baoright {
		float: left;
		width: 979px;
		background-color: #ffffff;
		padding: 20px;
		padding-bottom: 80px;
		min-height: 540px;
	}

	table {
		width: 950px;
		text-align: center;
		/* 表边框合并  两个单元格之间的边框进行合并 */
		border-collapse: collapse;
		margin: 0 auto;
		margin-top: 2px;
	}

	table td {
		border-width: 1px;
		border-style: solid;
		background-color: white;
		height: 40px;
		width: 100px;
		border: 1px #E0E0E0 solid;
	}

	table th {
		background-color: white;
		height: 40px;
		width: 100px;
	}

	.yusteon {
		font-weight: bold;
		width: 160px;
		font-size: 14px;
	}

	.yutext {
		text-align: left;
		padding-left: 20px;
		font-size: 14px;
	}

	.toptable {
		margin-top: 20px;
	}

	.divbut {
		margin-top: 50px;
	}

	.divbut button {
		width: 100px;
		height: 32px;
		margin-right: 20px;
	}

	footer {
		background-color: #b8d7ff;
		width: 100%;
		line-height: 60px;
		font-size: 14px;
		position: fixed;
		bottom: 0;
	}

	.kfoter {
		margin: 0px 20px;
	}
</style>
